import type { PropsWithChildren } from 'react';
import { useRef } from 'react';
import styled from 'styled-components';

import { FullViewportScroll } from '@sorare/core/src/atoms/container/FullViewportScroll';
import { WithScrollButtons } from '@sorare/core/src/atoms/navigation/WithScrollButtons';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const StyledFullViewportScroll = styled(FullViewportScroll)`
  @media ${tabletAndAbove} {
    mask-image: linear-gradient(
      to right,
      transparent,
      transparent calc(var(--container-padding) / 2),
      black var(--container-padding),
      black calc(100% - var(--container-padding)),
      transparent calc(100% - var(--container-padding) / 2),
      transparent 100%
    );
  }
`;
export const SlideShow = ({ children }: PropsWithChildren) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  return (
    <WithScrollButtons
      wrapperRef={wrapperRef}
      scrollContainerRef={scrollContainerRef}
      contained
    >
      <StyledFullViewportScroll ref={scrollContainerRef}>
        {children}
      </StyledFullViewportScroll>
    </WithScrollButtons>
  );
};
